import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'layout-blank',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './layout-blank.component.html',
  styleUrl: './layout-blank.component.scss'
})
export class LayoutBlankComponent {

}
